export default "/assets/images/mila-feed-13-thumbnail.jpg?1521e25fbd41dfeb909f630941339d55";